export default "__VITE_ASSET__YViob1PP__"